export default __webpack_public_path__ + "img/8860bd78e43f558c321cfe148312d2f6.png";